import { useEffect, useState } from 'react';
import Button from '../../../../components/Button/Button';
import Menu from '../../../../components/Menu/Menu';
import './Plates.scss';
import api from '../../../../js/api';

export default function Plates() {

    const [room, setRoom] = useState('');
    const [game_data, setGameData] = useState(null);

    useEffect(() => {
        const fetch_ = async () => {
            try {
                const response = await api.get(`/games/plates`);
                setGameData(response);
                console.log(response);
            } catch (error) {
                console.error(error);
            }
        }
        fetch_();
    }, []);

    const loadGameData = () => {
        if (!game_data)
            return <p>Loading...</p>;

        if (game_data.error) {
            console.error(game_data.error);
            return null;
        }

        return (
            game_data ? (
                game_data && !game_data.error ? (
                    <div className='game-data'>
                        <h3>Game data</h3>
                        {
                            Object.keys(game_data).map((key, index) => (
                                game_data[key] ?
                                    <p key={index}><b>{key}</b>: {game_data[key]}</p>
                                    :
                                    ''
                            ))
                        }
                    </div>
                ) : (
                    null
                )
            ) : (
                <p>Loading...</p>
            )
        )
    }

    return (
        <div id='plates'>
            <div className='centered-container'>
                <h1 className='title'>Plates</h1>
                <Button text="Create Room" onClick={(e) => {
                    console.log('Create Room');
                }} />
                <input type="number" className='plates-input' onChange={(e) => {
                    setRoom(e.target.value);
                }} />
                <Button text="Join Room" onClick={(e) => {
                    if (room == '') {
                        alert('Please enter a room number');
                        return;
                    }
                    console.log(`Join Room ${room}`);
                }} />
                <br />
                <br />
                {loadGameData()}

                <Menu title="" options={[
                    { name: 'Go Back', path: '/..' },
                ]} />
            </div>
        </div>
    );
}